import Component from '@glimmer/component';

export default class AppPage extends Component {}